export default __webpack_public_path__ + "static/media/5 - Установка тренажеров.accc583b.jpg";